import { Drawer, IconButton, Typography } from '@material-ui/core';
import React from 'react';
import RelationalDisplay from './RelationalDisplay';
import CloseIcon from '@material-ui/icons/Close';
import SubOptionForm from './SubOptionForm';

const SubInputsDrawer = ({
  open,
  row,
  rowState,
  column,
  columns,
  selectedType,
  handleChange,
  setOpen,
  title,
  rowIndex,
}) => {
  const [selectedOption, setSelectedOption] = React.useState(
    ((column || {}).options || {})[selectedType] || {}
  );

  React.useEffect(() => {
    setSelectedOption(column.options[selectedType] || {});
  }, [selectedType]);

  const setOptionChange = (value, index) => {
    let tempValueSet = [
      ...(rowState[selectedOption.key] ||
        selectedOption[selectedOption.key] ||
        []),
    ];
    tempValueSet[index] = value;
    handleChange(tempValueSet);
  };

  const commitFinalValues = (valueSet) => {
    handleChange(valueSet);
    setOpen(false);
  };

  const removeItem = (index) => {
    handleChange([
      ...(
        rowState[(selectedOption || {}).key] ||
        (selectedOption || {})[(selectedOption || {}).key] ||
        []
      ).filter((item, itemIndex) => itemIndex !== index),
    ]);
  };

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={() => setOpen(false)}
      disableEnforceFocus
      PaperProps={{
        style: {
          minWidth: '20vw',
          maxWidth: '25vw',
          paddingTop: 0,
        },
      }}
    >
      <div
        style={{ display: 'flex', width: '100%', justifyContent: 'flex-end' }}
      >
        <IconButton onClick={() => setOpen(false)}>
          <CloseIcon style={{ fontSize: 20, color: '#505050' }} />
        </IconButton>
      </div>
      <div style={{ padding: '0px 30px' }}>
        <div style={{ display: 'flex' }}>
          <Typography
            style={{
              color: '#505050',
              fontWeight: '900',
              marginBottom: 20,
              fontSize: 20,
              letterSpacing: 1,
            }}
          >
            {title}
          </Typography>
        </div>
        <RelationalDisplay {...{ row, rowIndex, rowState, column, columns }} />
        <SubOptionForm
          vertical
          row={row}
          column={column}
          handleChange={handleChange}
          rowState={rowState}
          addOptionEnabled={false}
          selectedOption={selectedOption || {}}
          inSideDrawer={true}
          commitFinalValues={commitFinalValues}
          content={
            rowState[(selectedOption || {}).key] ||
            (selectedOption || {})[(selectedOption || {}).key]
          }
          removeItem={removeItem}
          onChange={setOptionChange}
        />
      </div>
    </Drawer>
  );
};

export default SubInputsDrawer;
